import { SVGProps } from "react"

export const RightChevron = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 20 20" {...props}>
    <path stroke="#067BF2" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="m1.714 1.506 6.572 6.572-6.572 6.416" />
  </svg>
)
